// extracted by mini-css-extract-plugin
export default {"top-page-page":"styles_top-page-page__bbS9x"};